<template>
  <div class="index-title">
    {{title}}
  </div>
</template>

<script>

export default {
name: "indexTitle",
  props:['title'],
}
</script>

<style scoped lang="scss">
.index-title{
  width: 1400px;
  margin: 0 auto;
  //height: 11px;
  background-image: url('../../../assets/images/index-title-bg.png');
  background-repeat: no-repeat;
  background-position-y: 8px;
  font-size: 30px;
  text-align: center;
  line-height: 1;
}
</style>